import { Signal } from "@suse-o11y/signal";
import { createContext, useContext } from "react";

import { useRequiredContext } from "~/tools/use-required-context";

const WidgetContext = createContext<null | boolean>(null);

export const WidgetContextProvider = WidgetContext.Provider;

export const useIsWidgetExpandable = (): boolean =>
	useRequiredContext(WidgetContext, {
		providerName: "Widget",
	});

const WidgetExpandContext = createContext(Signal(new Map<string, boolean>()));

export const WidgetExpandContextProvider = WidgetExpandContext.Provider;

export const useWidgetExpandContext = (): Signal<Map<string, boolean>> => useContext(WidgetExpandContext);
